"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doesTaskNodeContainsVariableId = exports.doesConditionNodeContainVariableId = exports.doesExpressionDataContainVariableId = exports.doesNodeContainsVariableId = void 0;
/* eslint-disable no-use-before-define */
function doesNodeContainsVariableId(node, id) {
    switch (node.type) {
        case 'condition':
            return doesConditionNodeContainVariableId(node, id);
        case 'task':
            return doesTaskNodeContainsVariableId(node, id);
        default:
            return false;
    }
}
exports.doesNodeContainsVariableId = doesNodeContainsVariableId;
function doesExpressionDataContainVariableId(expression, id) {
    if (expression.left || expression.right) {
        const leftVar = expression.left && expression.left.variableId;
        const rightVar = expression.right && expression.right.variableId;
        return leftVar === id || rightVar === id;
    }
    if (expression.operands) {
        return expression.operands.some((v) => doesExpressionDataContainVariableId(v, id));
    }
    console.warn("Was trying to find variables on a expression  that didn't have either left/right or operands[]");
    return false;
}
exports.doesExpressionDataContainVariableId = doesExpressionDataContainVariableId;
function doesConditionNodeContainVariableId(node, id) {
    if (node.action !== 'expression') {
        return false;
    }
    const { expression } = node.data;
    return doesExpressionDataContainVariableId(expression, id);
}
exports.doesConditionNodeContainVariableId = doesConditionNodeContainVariableId;
const doesRichContentContainsVariable = (richContent, id) => richContent.properties &&
    richContent.properties.some(({ value }) => value.includes(id));
/**
 * Given that the property `value` attribute can be any one
 * of these primitive types:
 * - string
 * - number
 * - array
 * - date
 * - object
 *
 * We will JSON.stringify the value and perform a 'dumb' match on
 * the stringified value to find the variableId.
 *
 * In the future, we may want to switch on the `typeof value` and perform
 * 'smarter' checks on the content of `value`
 */
const doesSubjectContainVariable = (subject, id) => subject.includes(id);
function doesTaskNodeContainsVariableId(node, id) {
    if (node.type !== 'task') {
        throw new Error("Task node doesn't contain type 'task'", node);
    }
    const { data } = node;
    const { message, link, recipients } = data;
    // Check link, whether SMS or not
    if (link) {
        if (link.content.components.some((component) => doesRichContentContainsVariable(component, id))) {
            return true;
        }
        // Also check if the subject contains variables
        if (doesSubjectContainVariable(link.content.subject, id)) {
            return true;
        }
    }
    // Check recipients
    if (recipients) {
        if (recipients.some((v) => v.variableId === id)) {
            return true;
        }
    }
    switch (message.type) {
        case 'sms':
            // Just check  SMS body
            return message.content.body.includes(id);
        case 'email': {
            if (doesSubjectContainVariable(message.content && message.content.subject, id)) {
                return true;
            }
            // Check email body
            return message.content.components.some((component) => doesRichContentContainsVariable(component, id));
        }
        // undefined simply means when you've just added a webform node
        // and hasn't declared what type of channel it is
        case undefined:
            return false;
        default:
            throw new Error(`Message type not recognised: ${message.type}`);
    }
}
exports.doesTaskNodeContainsVariableId = doesTaskNodeContainsVariableId;
//# sourceMappingURL=nodeUtils.js.map